// Import components
import './components/header.js';
import './components/announcement-bar.js';
import './components/custom-collection-slider.js';
import './components/product-gallery.js';
// product-accordion.js removed - using global accordion-js system instead
import './components/related-products.js';
import './components/subscription-options.js';
import './components/product-recomendation.js';
import './components/complementary-products.js';
import './components/main-cart.js';
import './components/cart-drawer.js';
import './components/contact-form.js';
import './components/video-play-button.js';
import './components/account-aplication.js';
import './components/breadcrumbs.js';

document.addEventListener("DOMContentLoaded", function () {
  // Init general functionality here
  console.log('Product Detail Page components loaded');
});